import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import reducers from "../reducers";
import { routerMiddleware } from "react-router-redux";
import createHistory from "history/createBrowserHistory";
import { restoreAccountData } from "../services/authServices";
import authMiddleWare from "../middleware/authMiddleware";
import contentMiddleware from "../middleware/contentMiddleware";

export const history = createHistory({
    basename: "/"
});
const router = routerMiddleware(history);
export const initialState = buildInitialState();

export default function configureStore() {
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;//< = Added, this line must be removed before production
    let store = createStore(
        reducers,
        initialState,
        composeEnhancers(//< = Added, this line must be removed before production
            applyMiddleware(thunk, router, authMiddleWare, contentMiddleware)
        ),// < = Added, this line must be removed before production
    );
    //store.dispatch(push('/login'))
    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept("../reducers", () => {
            const nextReducer = require("../reducers").default; // eslint-disable-line global-require
            store.replaceReducer(nextReducer);
        });
    }
    return store;
}

function buildInitialState() {
    let accountData = restoreAccountData();
    let initialState = {};
    initialState.account = accountData
        ? accountData
        : {
            error: false,
            errorMsg: "",
            loggedIn: false,
            token: "",
            user: {
                id: null,
                name: "",
                email: "",
                username: "",
                created_at: "",
                updated_at: ""
            }
        };

    return initialState;
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js